// TESTING
// export const INACTIVITY_TIMEOUT = 60 * 1000 // 1 minute (was 30 min)
// export const ABSOLUTE_SESSION_TIMEOUT = 3 * 60 * 1000 // 3 minutes (was 24h)
// export const WARNING_DURATION = 15 * 1000 // 15 seconds (was 2 min)
// export const TOKEN_REFRESH_INTERVAL = 10 * 1000 // 10 seconds (was 60s)
// export const TOKEN_GRACE_PERIOD = 30 * 1000 // 30 seconds (was 5 min)
// export const ACTIVITY_THROTTLE = 2 * 1000
// ------------------------------------------------------------

// PRODUCTION
export const INACTIVITY_TIMEOUT = 30 * 60 * 1000
export const ABSOLUTE_SESSION_TIMEOUT = 24 * 60 * 60 * 1000
export const WARNING_DURATION = 2 * 60 * 1000
export const TOKEN_REFRESH_INTERVAL = 60 * 1000
export const TOKEN_GRACE_PERIOD = 5 * 60 * 1000
export const ACTIVITY_THROTTLE = 5 * 1000
// ------------------------------------------------------------

export const SESSION_START_KEY = 'sessionStartTs'
export const LAST_ACTIVITY_KEY = 'lastActivity'
export const SESSION_WARNING_KEY = 'sessionWarning'
export const CHECK_INTERVAL = 1000
